const VolumeController = ({ onChange, show, value }) => {
  if (!show) return null;

  return (
    <div className="volume-controller-range">
      <input type="range" min="0" max="100" value={value} onChange={onChange} />
    </div>
  );
};

export default VolumeController;
